import React from "react";

// Router
import { NavLink as RouterLink } from "react-router-dom";

// MUI
import { Button, Typography, makeStyles, Theme } from "@material-ui/core";

// Colors
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.type === "light" ? grey[50] : grey[700],
    padding: "1rem",
    borderRadius: 4
  },
  media: {
    height: 60,
    textAlign: "center",
    "& > img": {
      height: "100%",
      width: "auto"
    },
    fontWeight: 300
  },

  actions: {
    padding: theme.spacing(4, 2),
    display: "flex",
    justifyContent: "center"
  }
}));

const Permissions = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.media}>
        <Typography variant="h6">Current Plan</Typography>
      </div>
      <div>
        <Typography align="center" gutterBottom variant="h6" color="primary">
          Administrator
        </Typography>
        <Typography align="center" variant="body2">
          You have access to permissions, whitelabeling, analytics, auto
          scheduling for all your devices, and more
        </Typography>
      </div>
      <div className={classes.actions}>
        <Button
          color="primary"
          component={RouterLink}
          variant="contained"
          to="/plans"
        >
          Upgrade
        </Button>
      </div>
    </div>
  );
};

export default Permissions;
